import React, { useState, useMemo } from 'react';

const Collection = () => {
  const [selectedFilter, setSelectedFilter] = useState('newest');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [imageLoadingStates, setImageLoadingStates] = useState({});
  const itemsPerPage = 12;

  const collectionItems = [
    {
      id: 1,
      category: 'Gowns',
      title: 'Pink Flutter Gown',
      primaryImage: 'https://customer-assets.emergentagent.com/job_attire-fusion/artifacts/38dy0qfa_Gemini_Generated_Image_e4s5pke4s5pke4s5-images-2.jpg',
      secondaryImage: 'https://customer-assets.emergentagent.com/job_attire-fusion/artifacts/3fmg95qf_Gemini_Generated_Image_e4s5pke4s5pke4s5-images-1.jpg',
      date: '2025-01-15',
      popularity: 95
    },
    {
      id: 2,
      category: 'Jacket Sets',
      title: 'Navy Embroidered Jacket',
      primaryImage: 'https://customer-assets.emergentagent.com/job_attire-fusion/artifacts/suxfm5hm_Gemini_Generated_Image_e4s5pke4s5pke4s5-images-4.jpg',
      secondaryImage: 'https://customer-assets.emergentagent.com/job_attire-fusion/artifacts/clqd4ibz_Gemini_Generated_Image_e4s5pke4s5pke4s5-images-3.jpg',
      date: '2025-01-14',
      popularity: 92
    },
    {
      id: 3,
      category: 'Salwar Suits',
      title: 'Mustard Yellow Salwar',
      primaryImage: 'https://customer-assets.emergentagent.com/job_attire-fusion/artifacts/edy4hxf1_Gemini_Generated_Image_e4s5pke4s5pke4s5-images-7.jpg',
      secondaryImage: 'https://customer-assets.emergentagent.com/job_attire-fusion/artifacts/qbah4cg0_Gemini_Generated_Image_e4s5pke4s5pke4s5-images-8.jpg',
      date: '2025-01-13',
      popularity: 88
    },
    {
      id: 4,
      category: 'Kurti Sets',
      title: 'Off-White Tiered Kurta',
      primaryImage: 'https://customer-assets.emergentagent.com/job_attire-fusion/artifacts/glvoyoam_Gemini_Generated_Image_e4s5pke4s5pke4s5-images-18.jpg',
      secondaryImage: 'https://customer-assets.emergentagent.com/job_attire-fusion/artifacts/t5aks2jp_Gemini_Generated_Image_e4s5pke4s5pke4s5-images-19.jpg',
      date: '2025-01-12',
      popularity: 96
    },
    {
      id: 5,
      category: 'Anarkali Suits',
      title: 'Maroon Embroidered Jacket',
      primaryImage: 'https://customer-assets.emergentagent.com/job_attire-fusion/artifacts/26wfno5z_Gemini_Generated_Image_e4s5pke4s5pke4s5-images-22.jpg',
      secondaryImage: 'https://customer-assets.emergentagent.com/job_attire-fusion/artifacts/j8tc06p9_Gemini_Generated_Image_e4s5pke4s5pke4s5-images-23.jpg',
      date: '2025-01-11',
      popularity: 85
    },
    {
      id: 6,
      category: 'Jacket Sets',
      title: 'Brown Printed Jacket Set',
      primaryImage: 'https://customer-assets.emergentagent.com/job_attire-fusion/artifacts/5l68c64w_Gemini_Generated_Image_e4s5pke4s5pke4s5-images-34.jpg',
      secondaryImage: 'https://customer-assets.emergentagent.com/job_attire-fusion/artifacts/i5pl3mwi_Gemini_Generated_Image_e4s5pke4s5pke4s5-images-35.jpg',
      date: '2025-01-10',
      popularity: 90
    },
    {
      id: 7,
      category: 'Gharara Sets',
      title: 'Black Floral Gharara',
      primaryImage: 'https://customer-assets.emergentagent.com/job_attire-fusion/artifacts/0t8i4x3e_Gemini_Generated_Image_e4s5pke4s5pke4s5-images-26.jpg',
      secondaryImage: 'https://customer-assets.emergentagent.com/job_attire-fusion/artifacts/v5ji8a8h_Gemini_Generated_Image_e4s5pke4s5pke4s5-images-27.jpg',
      date: '2025-01-09',
      popularity: 87
    },
    {
      id: 8,
      category: 'Lehenga Sets',
      title: 'Red Embroidered Lehenga',
      primaryImage: 'https://images.unsplash.com/photo-1668371679302-a8ec781e876e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBldGhuaWMlMjB3ZWFyfGVufDB8fHx8MTc2OTQzMjY1OXww&ixlib=rb-4.1.0&q=85',
      secondaryImage: 'https://images.pexels.com/photos/12062663/pexels-photo-12062663.jpeg',
      date: '2025-01-08',
      popularity: 94
    },
    {
      id: 9,
      category: 'Saree Collection',
      title: 'Elegant Red Silk Saree',
      primaryImage: 'https://images.unsplash.com/photo-1618901185975-d59f7091bcfe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxzYXJlZXxlbnwwfHx8fDE3Njk0MzI2NzB8MA&ixlib=rb-4.1.0&q=85',
      secondaryImage: 'https://images.pexels.com/photos/30703866/pexels-photo-30703866.jpeg',
      date: '2025-01-07',
      popularity: 97
    },
    {
      id: 10,
      category: 'Lehenga Sets',
      title: 'Green Bridal Lehenga',
      primaryImage: 'https://images.unsplash.com/photo-1619715613791-89d35b51ff81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxsZWhlbmdhfGVufDB8fHx8MTc2OTQzMjY2NHww&ixlib=rb-4.1.0&q=85',
      secondaryImage: 'https://images.pexels.com/photos/13031909/pexels-photo-13031909.jpeg',
      date: '2025-01-06',
      popularity: 93
    },
    {
      id: 11,
      category: 'Indo-Western',
      title: 'Beige Gold Fusion Set',
      primaryImage: 'https://images.unsplash.com/photo-1571908599407-cdb918ed83bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBldGhuaWMlMjB3ZWFyfGVufDB8fHx8MTc2OTQzMjY1OXww&ixlib=rb-4.1.0&q=85',
      secondaryImage: 'https://images.unsplash.com/photo-1668371459824-094a960a227d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBldGhuaWMlMjB3ZWFyfGVufDB8fHx8MTc2OTQzMjY1OXww&ixlib=rb-4.1.0&q=85',
      date: '2025-01-05',
      popularity: 91
    },
    {
      id: 12,
      category: 'Saree Collection',
      title: 'Blue Floral Designer Saree',
      primaryImage: 'https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxzYXJlZXxlbnwwfHx8fDE3Njk0MzI2NzB8MA&ixlib=rb-4.1.0&q=85',
      secondaryImage: 'https://images.pexels.com/photos/1846014/pexels-photo-1846014.jpeg',
      date: '2025-01-04',
      popularity: 89
    },
    {
      id: 13,
      category: 'Lehenga Sets',
      title: 'Ivory Bridal Lehenga',
      primaryImage: 'https://images.unsplash.com/photo-1746372283841-dbb3838f9935?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxsZWhlbmdhfGVufDB8fHx8MTc2OTQzMjY2NHww&ixlib=rb-4.1.0&q=85',
      secondaryImage: 'https://images.unsplash.com/photo-1724856605022-106d6dd6e842?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxsZWhlbmdhfGVufDB8fHx8MTc2OTQzMjY2NHww&ixlib=rb-4.1.0&q=85',
      date: '2025-01-03',
      popularity: 98
    },
    {
      id: 14,
      category: 'Saree Collection',
      title: 'Green Traditional Saree',
      primaryImage: 'https://images.unsplash.com/photo-1679006831648-7c9ea12e5807?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxzYXJlZXxlbnwwfHx8fDE3Njk0MzI2NzB8MA&ixlib=rb-4.1.0&q=85',
      secondaryImage: 'https://images.unsplash.com/photo-1727430228383-aa1fb59db8bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxzYXJlZXxlbnwwfHx8fDE3Njk0MzI2NzB8MA&ixlib=rb-4.1.0&q=85',
      date: '2025-01-02',
      popularity: 86
    },
    {
      id: 15,
      category: 'Designer Collection',
      title: 'Royal Ethnic Ensemble',
      primaryImage: 'https://images.unsplash.com/photo-1569810020669-aa9d38003ea7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBldGhuaWMlMjB3ZWFyfGVufDB8fHx8MTc2OTQzMjY1OXww&ixlib=rb-4.1.0&q=85',
      secondaryImage: 'https://images.pexels.com/photos/3907103/pexels-photo-3907103.jpeg',
      date: '2025-01-01',
      popularity: 90
    },
    {
      id: 16,
      category: 'Festive Wear',
      title: 'Pink Festive Lehenga',
      primaryImage: 'https://images.pexels.com/photos/9418564/pexels-photo-9418564.jpeg',
      secondaryImage: 'https://images.pexels.com/photos/12062663/pexels-photo-12062663.jpeg',
      date: '2024-12-30',
      popularity: 92
    },
    {
      id: 17,
      category: 'Bridal Collection',
      title: 'Crimson Bridal Masterpiece',
      primaryImage: 'https://images.pexels.com/photos/12062663/pexels-photo-12062663.jpeg',
      secondaryImage: 'https://images.pexels.com/photos/13031909/pexels-photo-13031909.jpeg',
      date: '2024-12-29',
      popularity: 99
    },
    {
      id: 18,
      category: 'Floral Collection',
      title: 'Pink Floral Co-ord Set',
      primaryImage: 'https://images.unsplash.com/photo-1763971922552-fa9cbe06db7a',
      secondaryImage: 'https://images.unsplash.com/photo-1768651925875-d1523ed07cb6',
      date: '2024-12-28',
      popularity: 95
    },
    {
      id: 19,
      category: 'Floral Collection',
      title: 'Red Embroidered Floral Gown',
      primaryImage: 'https://images.unsplash.com/photo-1756483510821-424b7f6e44b0',
      secondaryImage: 'https://images.unsplash.com/photo-1765529374855-7353c3c47fc6',
      date: '2024-12-27',
      popularity: 93
    },
    {
      id: 20,
      category: 'Floral Saree',
      title: 'Traditional Floral Print Saree',
      primaryImage: 'https://images.unsplash.com/photo-1762780700769-6e02d6187f86',
      secondaryImage: 'https://images.pexels.com/photos/33431176/pexels-photo-33431176.jpeg',
      date: '2024-12-26',
      popularity: 91
    },
    {
      id: 21,
      category: 'Floral Lehenga',
      title: 'Ornate Green Floral Lehenga',
      primaryImage: 'https://images.unsplash.com/photo-1756483510809-122c56fbb035',
      secondaryImage: 'https://images.pexels.com/photos/33343606/pexels-photo-33343606.jpeg',
      date: '2024-12-25',
      popularity: 97
    },
    {
      id: 22,
      category: 'Floral Lehenga',
      title: 'Red Floral Twirl Lehenga',
      primaryImage: 'https://images.unsplash.com/photo-1756483557756-1b40cb0421f0',
      secondaryImage: 'https://images.unsplash.com/photo-1756483554416-1b2358bc916c',
      date: '2024-12-24',
      popularity: 94
    },
    {
      id: 23,
      category: 'Floral Collection',
      title: 'Blue Floral Print Ethnic Suit',
      primaryImage: 'https://images.unsplash.com/photo-1765529374929-beda4d71be01',
      secondaryImage: 'https://images.unsplash.com/photo-1764764860078-637c358bbfb9',
      date: '2024-12-23',
      popularity: 89
    },
    {
      id: 24,
      category: 'Floral Lehenga',
      title: 'Multi-Color Floral Lehenga',
      primaryImage: 'https://images.unsplash.com/photo-1756483571539-0785b86baa38',
      secondaryImage: 'https://images.pexels.com/photos/12762494/pexels-photo-12762494.jpeg',
      date: '2024-12-22',
      popularity: 96
    }
  ];

  // Get paginated items
  const paginatedItems = useMemo(() => {
    let sorted = [...collectionItems];
    
    // Apply sort filter
    switch (selectedFilter) {
      case 'newest':
        sorted = sorted.sort((a, b) => new Date(b.date) - new Date(a.date));
        break;
      case 'oldest':
        sorted = sorted.sort((a, b) => new Date(a.date) - new Date(b.date));
        break;
      case 'popular':
        sorted = sorted.sort((a, b) => b.popularity - a.popularity);
        break;
      default:
        break;
    }
    
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return sorted.slice(startIndex, endIndex);
  }, [currentPage, selectedFilter]);

  // Calculate total pages
  const totalPages = Math.ceil(collectionItems.length / itemsPerPage);

  // Handle filter change - reset to page 1
  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
    setCurrentPage(1);
  };

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Handle image load
  const handleImageLoad = (itemId, imageType) => {
    setImageLoadingStates(prev => ({
      ...prev,
      [`${itemId}-${imageType}`]: true
    }));
  };

  const openLightbox = (item) => {
    setSelectedItem(item);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setSelectedItem(null);
  };

  const handleBuyNow = (item) => {
    const message = `Hi, I'm interested in buying *${item.title}* from ${item.category}. Please share more details.`;
    const whatsappUrl = `https://wa.me/916392782674?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleCustomInquiry = (item) => {
    const message = `Hi, I'd like custom stitching for *${item.title}* style. Please share fabric options and pricing details.`;
    const whatsappUrl = `https://wa.me/916392782674?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="pt-20" data-testid="collection-page">
      {/* Hero Section */}
      <section className="relative h-[50vh] bg-cover bg-center" 
        style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1759840278381-bf7d5e332050?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920)' }}
      >
        <div className="absolute inset-0 bg-[#2B2B2B] bg-opacity-70"></div>
        <div className="relative h-full flex items-center justify-center text-center px-4">
          <div>
            <h1 className="font-playfair text-5xl sm:text-6xl lg:text-7xl text-[#F8F6F0] mb-4">
              Premium Salwar Suits
            </h1>
            <p className="font-montserrat text-lg text-[#D4AF37] tracking-widest">
              Exquisite Daily Elegance
            </p>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-8 px-4 bg-white border-b border-[#D4AF37]" data-testid="filter-section">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-center gap-4 flex-wrap">
            <button
              onClick={() => handleFilterChange('newest')}
              className={`font-montserrat text-sm px-6 py-2 tracking-widest transition-all duration-300 ${
                selectedFilter === 'newest'
                  ? 'bg-[#D4AF37] text-[#2B2B2B]'
                  : 'bg-[#F8F6F0] text-[#2B2B2B] hover:bg-[#D4AF37]'
              }`}
              data-testid="filter-newest"
            >
              NEWEST
            </button>
            <button
              onClick={() => handleFilterChange('oldest')}
              className={`font-montserrat text-sm px-6 py-2 tracking-widest transition-all duration-300 ${
                selectedFilter === 'oldest'
                  ? 'bg-[#D4AF37] text-[#2B2B2B]'
                  : 'bg-[#F8F6F0] text-[#2B2B2B] hover:bg-[#D4AF37]'
              }`}
              data-testid="filter-oldest"
            >
              OLDEST
            </button>
            <button
              onClick={() => handleFilterChange('popular')}
              className={`font-montserrat text-sm px-6 py-2 tracking-widest transition-all duration-300 ${
                selectedFilter === 'popular'
                  ? 'bg-[#D4AF37] text-[#2B2B2B]'
                  : 'bg-[#F8F6F0] text-[#2B2B2B] hover:bg-[#D4AF37]'
              }`}
              data-testid="filter-popular"
            >
              MOST POPULAR
            </button>
          </div>
          <div className="text-center mt-4">
            <p className="font-montserrat text-sm text-[#2B2B2B]">
              Showing {paginatedItems.length} of {collectionItems.length} items
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 px-4 bg-[#F8F6F0]" data-testid="gallery-grid">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {paginatedItems.map((item) => (
              <div 
                key={item.id}
                className="group relative overflow-hidden bg-white rounded-lg shadow-lg cursor-pointer"
                onClick={() => openLightbox(item)}
                data-testid={`collection-item-${item.id}`}
              >
                {/* Primary Image */}
                <div className="aspect-[3/4] overflow-hidden relative bg-gray-200">
                  {!imageLoadingStates[`${item.id}-primary`] && (
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="animate-pulse bg-gray-300 w-full h-full"></div>
                    </div>
                  )}
                  <img 
                    src={item.primaryImage} 
                    alt={item.title}
                    loading="lazy"
                    onLoad={() => handleImageLoad(item.id, 'primary')}
                    className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 group-hover:opacity-0 ${
                      imageLoadingStates[`${item.id}-primary`] ? 'opacity-100' : 'opacity-0'
                    }`}
                  />
                  {/* Secondary Image (shown on hover) */}
                  <img 
                    src={item.secondaryImage} 
                    alt={`${item.title} back view`}
                    loading="lazy"
                    onLoad={() => handleImageLoad(item.id, 'secondary')}
                    className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 opacity-0 group-hover:opacity-100`}
                  />
                </div>

                {/* Item Info */}
                <div className="p-4">
                  <h3 className="font-playfair text-lg text-[#2B2B2B] mb-2">
                    {item.title}
                  </h3>
                  <p className="font-montserrat text-xs text-[#2B2B2B]">
                    {item.category}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex justify-center items-center gap-2 mt-12">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`px-4 py-2 font-montserrat text-sm tracking-widest transition-all duration-300 ${
                  currentPage === 1
                    ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                    : 'bg-[#F8F6F0] text-[#2B2B2B] hover:bg-[#D4AF37]'
                }`}
              >
                PREV
              </button>
              
              {[...Array(totalPages)].map((_, index) => {
                const pageNum = index + 1;
                // Show first page, last page, current page, and pages around current
                if (
                  pageNum === 1 ||
                  pageNum === totalPages ||
                  (pageNum >= currentPage - 1 && pageNum <= currentPage + 1)
                ) {
                  return (
                    <button
                      key={pageNum}
                      onClick={() => handlePageChange(pageNum)}
                      className={`px-4 py-2 font-montserrat text-sm tracking-widest transition-all duration-300 ${
                        currentPage === pageNum
                          ? 'bg-[#D4AF37] text-[#2B2B2B]'
                          : 'bg-[#F8F6F0] text-[#2B2B2B] hover:bg-[#D4AF37]'
                      }`}
                    >
                      {pageNum}
                    </button>
                  );
                } else if (
                  pageNum === currentPage - 2 ||
                  pageNum === currentPage + 2
                ) {
                  return <span key={pageNum} className="px-2">...</span>;
                }
                return null;
              })}

              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`px-4 py-2 font-montserrat text-sm tracking-widest transition-all duration-300 ${
                  currentPage === totalPages
                    ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                    : 'bg-[#F8F6F0] text-[#2B2B2B] hover:bg-[#D4AF37]'
                }`}
              >
                NEXT
              </button>
            </div>
          )}
        </div>
      </section>

      {/* Lightbox Modal */}
      {lightboxOpen && selectedItem && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
          data-testid="lightbox-modal"
        >
          <button 
            onClick={closeLightbox}
            className="absolute top-4 right-4 text-white hover:text-[#D4AF37] transition-colors"
            data-testid="lightbox-close-button"
          >
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <div 
            className="max-w-4xl w-full bg-white rounded-lg overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="aspect-square">
                <img 
                  src={selectedItem.primaryImage} 
                  alt={selectedItem.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-8 flex flex-col justify-between">
                <div>
                  <span className="inline-block bg-[#D4AF37] text-[#2B2B2B] font-montserrat text-xs px-3 py-1 rounded-full mb-4">
                    {selectedItem.category}
                  </span>
                  <h2 className="font-playfair text-4xl text-[#2B2B2B] mb-6">
                    {selectedItem.title}
                  </h2>
                  <p className="font-montserrat text-sm text-[#2B2B2B] leading-relaxed mb-6">
                    Exquisitely crafted designer ethnic wear with intricate embroidery and premium fabric. 
                    Perfect for daily wear, festive occasions, and special celebrations. This piece represents 
                    the perfect blend of traditional Indian craftsmanship and contemporary design aesthetics.
                  </p>
                </div>
                <div className="flex flex-col gap-3">
                  <button 
                    onClick={() => handleBuyNow(selectedItem)}
                    className="w-full bg-[#D4AF37] text-[#2B2B2B] font-montserrat py-4 text-sm tracking-widest hover:bg-[#2B2B2B] hover:text-[#D4AF37] transition-colors duration-300 flex items-center justify-center gap-2"
                    data-testid="buy-now-button"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    BUY NOW - READY TO WEAR
                  </button>
                  <button 
                    onClick={() => handleCustomInquiry(selectedItem)}
                    className="w-full bg-[#2B2B2B] text-[#F8F6F0] font-montserrat py-4 text-sm tracking-widest hover:bg-[#D4AF37] hover:text-[#2B2B2B] transition-colors duration-300 flex items-center justify-center gap-2"
                    data-testid="inquire-button"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    CUSTOM STITCHING INQUIRY
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Collection;
